export const DEFAULT_MARKER_IMAGE = {
  name: "Default Marker",
  tags: ["default"],
  waID: "",
  path: "images/markers/backup/marker-icon-blue.png",
  identifier: "default",
  width: 24,
  height: 40,
};

export const DEFAULT_TEMPLATE_OVERRIDES = {
  name: "",
  mode: "image",
  pinImg: "",
  iconGlyph: "",
  primaryColor: "",
  width: 24,
  height: 40,
  lockAspectRatio: true,
  anchorX: 12,
  anchorY: 40,
  borderEnabled: false,
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: "transparent",
  tooltipEnabled: true,
  customClassName: "",
};
export const DEFAULT_TEMPLATEa = {
  ...DEFAULT_TEMPLATE_OVERRIDES,
  pinImg: { ...DEFAULT_MARKER_IMAGE },
  // pinImg: { ...DEFAULT_MARKER_IMAGE, x: 123 },
  // pinImg: Object.create({ ...DEFAULT_MARKER_IMAGE, x: 123 }),
  name: "Default",
  _id: "",
};
export function DefaultTemplate() {
  return {
    ...getDefaultOverrides(),
    ...getDefaultImage(),
  };
}

export function getDefaultOverrides() {
  return {
    name: "",
    mode: "image",
    pinImg: "",
    iconGlyph: "",
    primaryColor: "",
    width: 24,
    height: 40,
    lockAspectRatio: true,
    anchorX: 12,
    anchorY: 40,
    borderEnabled: false,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "transparent",
    tooltipEnabled: true,
    customClassName: "",
    filter: "",
  };
}

export function getDefaultImage() {
  return {
    pinImg: {
      name: "Default Marker",
      tags: ["default"],
      waID: "",
      path: "images/markers/backup/marker-icon-blue.png",
      identifier: "default",
      width: 24,
      height: 40,
    },
  };
}

export const EmptyMonth = getEmptyMonth();

export function getEmptyMonth() {
  return {
    name: "",
    days: 0,
    leapDays: 0,
    leapPeriod: 0,
  };
}

export function getDefaultSettings() {
  return {
    title: "",
    description: "",
    private: false,
    subGroups: [],
    defaultUnit: "year",
    yearInitQty: 1000,
    startDate: "0",
  };
}
// export const DEFAULT_TEMPLATE = new DefaultTemplate();

// export const DEFAULT_TEMPLATE = Object.freeze({
//   ...DEFAULT_TEMPLATE_OVERRIDES,
//   // pinImg: { ...DEFAULT_MARKER_IMAGE },
//   pinImg: Object.freeze({ ...DEFAULT_MARKER_IMAGE, x: 123 }),
//   name: 'Default',
//   _id: '',
// });

export function getTimeUnitOptions() {
  return [
    { name: "Minutes", value: "minute" },
    { name: "Hours", value: "hour" },
    { name: "Days", value: "day" },
    { name: "Years", value: "year" },
    { name: "Decades", value: "decade" },
    { name: "Centuries", value: "century" },
    { name: "Millenia", value: "millenium" },
    { name: "Myriads", value: "myriad" },
    { name: "Epochs", value: "epoch" },
    { name: "Aeons", value: "aeon" },
  ];
}

export function getDefaultCoverImageURL(preferredColor = "light") {
  switch (preferredColor) {
    case "green":
      return "https://www.worldanvil.com/images/placeholder-green.jpg";
    case "cyan":
      return "https://www.worldanvil.com/images/placeholder-cyan.jpg";
    case "orange":
      return "https://www.worldanvil.com/images/placeholder-orange.jpg";
    case "red":
      return "https://www.worldanvil.com/images/placeholder-red.jpg";
    case "light":
    default:
      return "https://www.worldanvil.com/images/placeholder-light-1.jpg";
  }
}
